import { render, staticRenderFns } from "./AppWizard.vue?vue&type=template&id=18342d0b"
import script from "./AppWizard.vue?vue&type=script&lang=js"
export * from "./AppWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports